//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../../components/helpers.js'
import ImageViewer from '../../../components/Images/ImageViewer.vue'
import { axiosPost } from '../../../axios/axios.js'
import Table from '../../../components/Table/Table.vue'
import ReportArhiveExpansion from './ReportArhiveExpansion.vue'
import { getToken } from './reportArhive.js'

export default {
  components: {
    ImageViewer,
    Table,
    ReportArhiveExpansion
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    objectTypeName: {
      type: String,
      default: ''
    },
    objectType: {
      type: String,
      default: ''
    },
    legendConfigTypes: {
      type: Object,
      default () {
        return {}
      }
    },
    troubleTypeConfig: {
      type: Array,
      default () {
        return []
      }
    },
    token: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      data: [],
      columns: [
        {
          name: 'name',
          align: 'left',
          field: 'name'
        },
        {
          name: 'value',
          align: 'left',
          field: 'value'
        }
      ],
      columnsMaterialDescription: [
        {
          name: 'name',
          align: 'left',
          field: 'name',
          style: 'width: 150px'
        },
        {
          name: 'value',
          align: 'left',
          field: 'value'
        }
      ],
      columnsEquipment: [
        {
          name: 'remote',
          label: 'Демонтировано',
          align: 'left',
          field: 'remote',
          style: 'width: 50%'
        },
        {
          name: 'install',
          label: 'Установлено',
          align: 'left',
          field: 'install',
          style: 'width: 50%'
        }
      ],
      dataEquipments: [],
      dataFilledEngineer: [],
      dataRoadInfo: [],
      dataMarkerComplex: [{ name: 'Идентификатор комплекса (ID детектора) нанесенного на бокс', value: '' }],
      dataDemounting: [
        { key: 'number_old', name: 'Старый ID детектора', value: '' },
        { key: 'coordinates_old', name: 'Старые координаты', value: '' },
        { key: 'disassembling_address', name: 'Адрес демонтажа', value: '' }
      ],
      dataAudit: [],
      dataCameras: [],
      columnsCameras: [],
      dataMaterials: [],
      dataMaterialDescription: [{ name: 'Расходные материалы', value: '-' }],
      columnsMaterials: [
        {
          name: 'name',
          label: 'Материал',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'quantity',
          label: 'Использовано',
          align: 'left',
          field: (row) => row.quantity + ' ' + row.unit_name,
          format: value => {
            return value
          }
        }
      ].concat(!this.objectType.includes('pto') ? [{
        name: 'residue',
        label: 'Остаток на складе',
        align: 'left',
        field: (row) => row.residue + ' ' + row.unit_name,
        format: value => {
          return value
        }
      },
      {
        name: 'stock1c_name',
        label: 'Склад 1C',
        align: 'left',
        field: 'stock1c_name'
      },
      {
        name: 'project_name',
        label: 'Проект',
        align: 'left',
        field: 'project_name'
      }] : []),
      photos: [],
      category: null,
      baseUrlImage: 'api-v1/api-act-objects/get-photo',
      baseUrlFile: 'api-v1/api-act-objects/get-file',
      showNoteRework: false,
      showNoteChecked: false,
      expandedJobs: true,
      photosStatus: {},
      filesStatus: {},
      expansionItems: [],
      pagination: {
        rowsPerPage: 1000
      },
      dataComplexCameras: [],
      dataPtoObject: null,
      columnPtoObject: null
    }
  },
  watch: {
    'photosStatus.expansion': function (expansions) {
      expansions.forEach((expansion, index) => {
        if (expansion) {
          this.loadPhoto(index)
        }
      })
    },
    'filesStatus.expansion': function (expansion) {
      if (expansion) {
        this.loadFile()
      }
    },
    'report.object.objectLink': function (link) {
      const _objectTypeName = this.objectTypeName
      const _index = this.data.findIndex(item => item.name == 'Объект ' + _objectTypeName)
      if (_index !== -1 && link) {
        this.$set(this.data[_index], 'objectLink', link)
      }
    },
    'report.create.employee_link': function (link) {
      const _index = this.data.findIndex(item => ['Создатель акта', 'Акт создал'].includes(item.name))
      if (_index !== -1 && link) {
        this.$set(this.data[_index], 'link', link)
      }
      if (['table', 'detector'].includes(this.objectType)) {
        const _index2 = this.data.findIndex(item => item.name == 'Оператор')
        if (_index2 !== -1 && link) {
          this.$set(this.data[_index2], 'link', link)
        }
      }
    },
    'report.upprove.employee_link': function (link) {
      const _index = this.data.findIndex(item => item.name == 'Диспетчер')
      if (_index !== -1 && link) {
        this.$set(this.data[_index], 'link', link)
      }
      if (this.objectType == 'kto') {
        const _index2 = this.data.findIndex(item => item.name == 'Оператор')
        if (_index2 !== -1 && link) {
          this.$set(this.data[_index2], 'link', link)
        }
      }
    },
    'report.work.employee_link': function (link) {
      const _index = this.data.findIndex(item => ['Ответственный', 'Инженер'].includes(item.name))
      if (_index !== -1 && link) {
        this.$set(this.data[_index], 'link', link)
      }
    },
    'report.audit.employee_link': function (link) {
      const _index = this.data.findIndex(item => item.name == 'Аудитор')
      if (_index !== -1 && link) {
        this.$set(this.data[_index], 'link', link)
      }
    },
    'report.auto.employee_link': function (link) {
      const _index = this.data.findIndex(item => item.name == 'Водитель')
      if (_index !== -1 && link) {
        this.$set(this.data[_index], 'link', link)
      }
    },
    'report.brigade.employee_link': function (link) {
      const _index = this.data.findIndex(item => item.name == 'Сотрудник')
      if (_index !== -1 && link) {
        this.$set(this.data[_index], 'link', link)
      }
    },
    'report.brigade.links': function (link) {
      const _index = this.data.findIndex(item => item.name == 'Состав бригады на момент создания акта')
      if (_index !== -1 && link) {
        this.$set(this.data[_index], 'links', link)
      }
    },
    'report.work.installer_link': function (link) {
      const _index = this.data.findIndex(item => item.name == 'Монтажник')
      if (_index !== -1 && link) {
        this.$set(this.data[_index], 'link', link)
      }
    },
    'report.claims.external': function (external) {
      external.forEach((item, index) => {
        const claimIndex = this.expansionItems.findIndex(element => element.key == 'external_' + index)
        const dataCreatorIndex = this.expansionItems[claimIndex].data.findIndex(element => element.name == 'Заявку создал')
        this.$set(this.expansionItems[claimIndex].data[dataCreatorIndex], 'link', item.link)
      })
    },
    'report.claims.internal': function (internal) {
      internal.forEach((item, index) => {
        const claimIndex = this.expansionItems.findIndex(element => element.key == 'internal_' + index)
        const dataCreatorIndex = this.expansionItems[claimIndex].data.findIndex(element => element.name == 'Заявку создал')
        this.$set(this.expansionItems[claimIndex].data[dataCreatorIndex], 'link', item.link)
      })
    }
  },
  created: function () {
    this.data = []
    this.dataMaterials = []
    this.photos = []
    const ptoActType = ['pto_tl', 'pto_t7', 'pto_detector', 'pto_table', 'pto_kto', 'pto_fvf']
    this.$nextTick(() => {
      if (this.report) {
        if (this.objectType.includes('pto')) {
          this.dataPtoObject = this.report.act.pto_object_attributes
          this.columnPtoObject = ['name', 'value'].map(item => {
            return {
              name: item,
              align: 'left',
              field: item,
              sortable: true
            }
          })
        }
        if (this.report && this.report.act.files && this.report.act.files.length) {
          this.filesStatus = {}
          this.$set(this.filesStatus, 'act', this.objectType + '_' + this.report.act.id)
          this.$set(this.filesStatus, 'status', { name: 'Вложенные файлы', count: this.report.act.files.length, loading: true })
          this.$set(this.filesStatus, 'expansion', false)
          this.$set(this.filesStatus, 'files', this.report.act.files)
          this.$set(this.filesStatus, 'filesData', [])
          // const _expansion = []
        }
        if (this.report && this.report.photos && this.report.photos.length) {
          this.photosStatus = {}
          this.$set(this.photosStatus, 'act', this.objectType + '_' + this.report.act.id)
          this.$set(this.photosStatus, 'status', [])
          this.$set(this.photosStatus, 'expansion', [])
          this.$set(this.photosStatus, 'photos', [])
          // const _expansion = []
          this.report.photos.forEach(item => {
            let statusIndex = this.photosStatus.status.findIndex(status => status.name == item.status_name)
            if (statusIndex == -1) {
              this.photosStatus.status.push({ name: item.status_name, count: 0, loading: true })
              this.photosStatus.expansion.push(false)
              statusIndex = this.photosStatus.status.length - 1
              this.photosStatus.photos[statusIndex] = []
            }
            this.$set(this.photosStatus.status[statusIndex], 'count', this.photosStatus.status[statusIndex].count + 1)
            this.$set(this.photosStatus.status[statusIndex], 'loading', false) // true
          })
        }
        const data = []
        const objectType = this.objectType
        if (this.report.act.add_date !== undefined) {
          data.push({
            name: 'Дата акта',
            article: [{ key: 'tl', index: 1 }, { key: 't7', index: 1 }],
            value: this.formatDateTime(this.report.act.add_date),
            expansion: 'main'
          })
        }
        data.push({
          name: ['tl', 't7'].includes(objectType) ? 'Создатель акта' : 'Акт создал',
          article: [{ key: 'detector', index: 1 }, { key: 'tl', index: 3 }, { key: 't7', index: 3 }],
          value: this.report.create.employee_name,
          link: this.report.create.employee_link !== undefined ? this.report.create.employee_link : null,
          expansion: 'main'
        })
        if (this.report.brigade.employee_name !== undefined) {
          data.push({
            name: 'Сотрудник',
            article: [{ key: 'tl', index: 12 }, { key: 't7', index: 12 }],
            value: this.report.brigade.employee_name,
            link: this.report.brigade.employee_link !== undefined ? this.report.brigade.employee_link : null,
            expansion: 'main'
          })
        }

        if (this.report.act.modify_date !== undefined) {
          data.push({
            name: 'Дата одобрения',
            article: [{ key: 'tl', index: 4 }, { key: 't7', index: 4 }],
            value: this.formatDateTime(this.report.act.modify_date),
            expansion: 'main'
          })
        }
        data.push({
          name: 'Диспетчер',
          article: [{ key: 'tl', index: 5 }, { key: 't7', index: 5 }],
          value: this.report.upprove.employee_name,
          link: this.report.upprove.employee_link !== undefined ? this.report.upprove.employee_link : null,
          expansion: 'main'
        })
        data.push({ name: 'Статус акта', article: [{ key: 'table', index: 1 }, { key: 'kto', index: 1 }, { key: 'fvf', index: 1 }], value: this.report.state.name })
        if (this.report.act.act_type_name !== undefined) {
          data.push({ name: 'Тип акта', article: [{ key: 'kto', index: 2 }, { key: 'fvf', index: 2 }], value: this.report.act.act_type_name })
        }
        const ptoCreateTime = ptoActType.map(element => {
          return { key: element, index: 1 }
        })
        data.push(Object.assign({
          name: ['tl', 't7'].includes(objectType) ? 'Фактическое время создания акта' : 'Время создания акта',
          article: [{ key: 'table', index: 2 },
            { key: 'detector', index: 2 },
            { key: 'tl', index: 2 },
            { key: 't7', index: 2 },
            { key: 'kto', index: 3 },
            { key: 'fvf', index: 3 }].concat(ptoCreateTime),
          value: this.formatDateTime(this.report.create.time)
        }, !ptoActType.includes(objectType) ? { expansion: 'main' } : {}))
        const ptoUpdateTime = ptoActType.map(element => {
          return { key: element, index: 2 }
        })
        data.push({
          name: 'Время изменения акта',
          article: [{ key: 'table', index: 3 }, { key: 'detector', index: 19 }, { key: 'kto', index: 4 }, { key: 'fvf', index: 4 }].concat(ptoUpdateTime),
          value: this.formatDateTime(this.report.upprove.time)
        })
        data.push({
          name: 'Адрес ' + (['kto'].includes(objectType) ? 'монтажа' : ''),
          article: [{ key: 'detector', index: 14 }, { key: 'kto', index: 16 }],
          value: this.report.object.address
        })
        data.push({
          name: 'Монтажник',
          article: [{ key: 'detector', index: 10 }],
          value: this.report.work.installer_name,
          link: this.report.work.installer_link !== undefined ? this.report.work.installer_link : null
        })
        data.push({ name: 'Округ', article: [{ key: 'detector', index: 11 }], value: this.report.object.area })
        if (this.report.object.type_object_name !== undefined) {
          data.push({
            name: 'Тип объекта',
            article: [{ key: 'tl', index: 7 }, { key: 't7', index: 7 }],
            value: this.report.object.type_object_name,
            expansion: 'main'
          })
        }
        if (this.report.object.type_name !== undefined) {
          data.push({
            name: ['tl', 't7'].includes(objectType) ? 'Тип контроллера' : 'Тип датчика',
            article: [{ key: 'detector', index: 16 }, { key: 'tl', index: 16 }, { key: 't7', index: 16 }],
            value: this.report.object.type_name.value,
            object: this.report.object.type_name.main !== undefined ? this.report.object.type_name.main : '',
            synchronical: this.report.object.type_name.synchronical,
            expansion: 'main'
          })
        }

        if (this.report.object.electrosupply !== undefined) {
          data.push({
            name: 'Тип электроснабжения',
            article: [{ key: 'tl', index: 8 }, { key: 't7', index: 8 }],
            value: this.report.object.electrosupply.value,
            synchronical: this.report.object.electrosupply.synchronical,
            expansion: 'main'
          })
        }
        if (this.report.object.type_add !== undefined) {
          data.push({
            name: 'Дополнительный контроллер',
            article: [{ key: 'tl', index: 17 }, { key: 't7', index: 17 }],
            value: this.report.object.type_add.in_act_value,
            synchronical: this.report.object.type_add.synchronical,
            object: this.report.object.type_add.value,
            expansion: 'main'
          })
        }
        if (this.report.object.current_control_before !== undefined) {
          data.push({
            name: 'Контроль тока (ППК) До',
            article: [{ key: 'tl', index: 18 }, { key: 't7', index: 18 }],
            value: this.report.object.current_control_before.in_act_value,
            synchronical: this.report.object.current_control_before.synchronical,
            object: this.report.object.current_control_before.value,
            icon: {
              name: 'mdi-check-circle-outline',
              color: this.report.object.current_control_before.not_required ? 'negative' : 'green-8',
              tooltip: !this.report.object.current_control_before.not_required ? 'Обязательно к заполнению' : 'Не обязательно к заполнению'
            },
            expansion: 'main'
          })
        }
        if (this.report.object.current_control !== undefined) {
          data.push({
            name: 'Контроль тока (ППК) После',
            article: [{ key: 'tl', index: 19 }, { key: 't7', index: 19 }],
            value: this.report.object.current_control.in_act_value,
            synchronical: this.report.object.current_control.synchronical,
            object: this.report.object.current_control.value,
            icon: {
              name: 'mdi-check-circle-outline',
              color: this.report.object.current_control.not_required ? 'negative' : 'green-8',
              tooltip: !this.report.object.current_control.not_required ? 'Обязательно к заполнению' : 'Не обязательно к заполнению'
            },
            expansion: 'main'
          })
        }
        if (this.report.object.current_control_checked !== undefined) {
          data.push({
            name: 'Физическая проверка срабатывания КК',
            article: [{ key: 'tl', index: 20 }, { key: 't7', index: 20 }],
            value: this.report.object.current_control_checked.in_act_value,
            synchronical: this.report.object.current_control_checked.synchronical,
            object: this.report.object.current_control_checked.value,
            expansion: 'main'
          })
        }
        if (this.report.object.time_zone_offset !== undefined) {
          data.push({
            name: 'Смещение часового пояса относительно Мск (только Swarco)',
            article: [{ key: 'tl', index: 21 }, { key: 't7', index: 21 }],
            value: this.report.object.time_zone_offset.in_act_value,
            synchronical: this.report.object.time_zone_offset.synchronical,
            object: this.report.object.time_zone_offset.value === null ? '(Не задано)' : this.report.object.time_zone_offset.value,
            expansion: 'main'
          })
        }
        if (this.report.object.ip !== undefined) {
          data.push({
            name: 'IP адрес',
            article: [{ key: 'tl', index: 22 }, { key: 't7', index: 22 }],
            value: this.report.object.ip.in_act_value,
            synchronical: this.report.object.ip.synchronical,
            object: this.report.object.ip.value,
            expansion: 'main'
          })
        }
        if (this.report.object.passport !== undefined) {
          data.push({
            name: 'Проверка паспорта СО',
            article: [{ key: 'tl', index: 23 }, { key: 't7', index: 23 }],
            value: this.report.object.passport.in_act_value,
            synchronical: this.report.object.passport.synchronical,
            object: this.report.object.passport.value,
            expansion: 'main'
          })
        }
        if (this.report.object.lock_type !== undefined) {
          data.push({
            name: 'Тип замка',
            article: [{ key: 'tl', index: 24 }, { key: 't7', index: 24 }],
            value: this.report.object.lock_type.in_act_value,
            synchronical: this.report.object.lock_type.synchronical,
            object: this.report.object.lock_type.value,
            expansion: 'main'
          })
        }
        if (this.report.object.locking_arm !== undefined) {
          data.push({
            name: 'Проверка запорного устройства',
            article: [{ key: 'tl', index: 25 }, { key: 't7', index: 25 }],
            value: this.report.object.locking_arm.in_act_value,
            synchronical: this.report.object.locking_arm.synchronical,
            object: this.report.object.locking_arm.value,
            expansion: 'main'
          })
        }
        if (this.report.object.cisco !== undefined) {
          data.push({
            name: 'Проверка запорного устройства',
            article: [{ key: 'tl', index: 26 }, { key: 't7', index: 26 }],
            value: this.report.object.cisco.in_act_value,
            synchronical: this.report.object.cisco.synchronical,
            object: this.report.object.cisco.value,
            expansion: 'main'
          })
        }
        if (this.report.object.stand_state !== undefined) {
          data.push({
            name: 'Проверка подставки (мангала)',
            article: [{ key: 'tl', index: 27 }, { key: 't7', index: 27 }],
            value: this.report.object.stand_state.in_act_value,
            synchronical: this.report.object.stand_state.synchronical,
            object: this.report.object.stand_state.value,
            expansion: 'main'
          })
        }
        if (this.report.object.peek_license !== undefined) {
          data.push({
            name: 'Лицензия Peek',
            article: [{ key: 'tl', index: 28 }, { key: 't7', index: 28 }],
            value: this.report.object.peek_license.in_act_value,
            synchronical: this.report.object.peek_license.synchronical,
            object: this.report.object.peek_license.value,
            expansion: 'main'
          })
        }
        if (this.report.object.ctd !== undefined) {
          data.push({
            name: 'Соответствие технической документации',
            article: [{ key: 'tl', index: 29 }, { key: 't7', index: 29 }],
            value: this.report.object.ctd.in_act_value,
            synchronical: this.report.object.ctd.synchronical,
            object: this.report.object.ctd.value,
            expansion: 'main'
          })
        }
        if (this.report.act.set_arrow !== undefined) {
          data.push({
            name: 'Требуется нанесение контурных стрелок',
            article: [{ key: 'tl', index: 31 }, { key: 't7', index: 31 }],
            value: this.report.act.set_arrow,
            expansion: 'main'
          })
        }
        if (this.report.act.need_tower !== undefined) {
          data.push({
            name: 'Требуется вышка',
            article: [{ key: 'tl', index: 32 }, { key: 't7', index: 32 }],
            value: this.report.act.need_tower,
            expansion: 'main'
          })
        }
        if (this.report.act.note_not_ctd !== undefined) {
          data.push({
            name: 'Примечание по не соответствию технической документации',
            article: [{ key: 'tl', index: 30 }, { key: 't7', index: 30 }],
            value: this.report.act.note_not_ctd,
            html: true,
            expansion: 'main'
          })
        }
        if (this.report.object.amperage !== undefined) {
          data.push({
            name: 'Замер потребляемого тока СО(приложить фото)',
            article: [{ key: 'tl', index: 9 }, { key: 't7', index: 9 }],
            value: this.report.object.amperage,
            expansion: 'main'
          })
        }
        if (this.report.object.type_addition !== undefined) {
          data.push({
            name: 'Доп.информация к датчику SMS',
            article: [{ key: 'detector', index: 17 }],
            value: this.report.object.type_addition.value,
            synchronical: this.report.object.type_addition.synchronical
          })
        }

        data.push({ name: 'Ориентация (для SMS)', article: [{ key: 'detector', index: 18 }], value: this.report.object.orientation })
        const ptoExecuteTime = ptoActType.map(element => {
          return { key: element, index: 3 }
        })
        data.push({
          name: 'Время выполнения работ',
          article: [{ key: 'table', index: 4 }, { key: 'detector', index: 8 }, { key: 'kto', index: 5 }, { key: 'fvf', index: 6 }].concat(ptoExecuteTime),
          value: this.formatDateTime(this.report.work.time)
        })
        if (this.report.act.priority_name !== undefined) {
          data.push({
            name: 'Приоритет задания',
            article: [{ key: 'kto', index: 6 }, { key: 'fvf', index: 5 }],
            value: this.report.act.priority_name
          })
        }
        if (this.report.object.checkout_status !== undefined) {
          data.push({
            name: 'Условие выезда',
            article: [{ key: 'kto', index: 7 }],
            value: this.report.object.checkout_status.value
          })
        }
        data.push({
          name: 'Примечание' + (['tl', 't7'].includes(objectType) ? ' по акту' : ''),
          article: [{ key: 'table', index: 5 }, { key: 'tl', index: 33 }, { key: 't7', index: 33 }, { key: 'kto', index: 8 }, { key: 'fvf', index: 7 }],
          value: this.report.create.note,
          html: true,
          expansion: 'main'
        })
        data.push({
          name: 'Оператор',
          article: [{ key: 'table', index: 6 }, { key: 'detector', index: 3 }, { key: 'kto', index: 9 }],
          value: this.report[objectType == 'kto' ? 'upprove' : 'create'].employee_name,
          link: this.report[objectType == 'kto' ? 'upprove' : 'create'].employee_link !== undefined ? this.report[objectType == 'kto' ? 'upprove' : 'create'].employee_link : null
        })
        const ptoBrigade = ptoActType.map(element => {
          return { key: element, index: 4 }
        })
        data.push(Object.assign({
          name: 'Бригада',
          article: [{ key: 'table', index: 7 },
            { key: 'tl', index: 10 }, { key: 't7', index: 10 }, { key: 'kto', index: 10 },
            { key: 'fvf', index: 8 }].concat(ptoBrigade),
          value: this.report.brigade.name
        }, !ptoActType.includes() ? { expansion: 'main' } : {}))
        const brigadeEmployees = this.report.brigade.employees !== undefined ? this.report.brigade.employees : []
        data.push({
          name: 'Состав бригады на момент создания акта',
          article: [{ key: 'tl', index: 11 }, { key: 't7', index: 11 }],
          value: brigadeEmployees,
          links: this.report.brigade.links !== undefined ? this.report.brigade.links : null,
          expansion: 'main'
        })
        const ptoEngineer = ptoActType.map(element => {
          return { key: element, index: 6 }
        })
        data.push({
          name: ['fvf'].includes(objectType) ? 'Ответственный' : 'Инженер',
          article: [{ key: 'table', index: 8 }, { key: 'detector', index: 4 }, { key: 'kto', index: 12 }, { key: 'fvf', index: 10 }].concat(ptoEngineer),
          value: this.report.work.employee_name,
          link: this.report.work.employee_link !== undefined ? this.report.work.employee_link : null
        })
        const ptoAutocar = ptoActType.map(element => {
          return { key: element, index: 5 }
        })
        data.push(Object.assign({
          name: 'Авто',
          article: [
            { key: 'table', index: 9 }, { key: 'detector', index: 5 }, { key: 'tl', index: 34 }, { key: 't7', index: 34 },
            { key: 'kto', index: 11 }, { key: 'fvf', index: 9 }
          ].concat(ptoAutocar),
          value: this.report.auto.id !== '' ? (this.report.auto.number + ' - ' + this.report.auto.description) : '(Не задано)'
        }, !ptoActType.includes() ? { expansion: 'main' } : {}))
        if (this.report.auto.driver !== undefined) {
          data.push({
            name: 'Водитель',
            article: [{ key: 'tl', index: 35 }, { key: 't7', index: 35 }],
            value: this.report.auto.driver,
            link: this.report.auto.employee_link !== undefined ? this.report.auto.employee_link : null,
            expansion: 'main'
          })
        }
        const ptoNoteEngineer = ptoActType.map(element => {
          return { key: element, index: 7 }
        })
        data.push({
          name: 'Примечание инженера',
          article: [{ key: 'table', index: 10 }, { key: 'detector', index: 9 }, { key: 'kto', index: 13 }, { key: 'fvf', index: 11 }].concat(ptoNoteEngineer),
          value: this.report.work.note
        })
        if (this.report.object.contract !== undefined) {
          data.push({
            name: 'Контракт',
            article: [{ key: 'tl', index: 13 }, { key: 't7', index: 13 }],
            value: this.report.object.contract,
            html: true,
            expansion: 'main'
          })
        }
        data.push({
          name: 'Контракт(проект)',
          article: [
            { key: 'table', index: 11 }, { key: 'detector', index: 13 }, { key: 'tl', index: 14 }, { key: 't7', index: 14 },
            { key: 'kto', index: 14 }, { key: 'fvf', index: 12 }],
          value: this.report.project.id !== '' ? this.report.project.name : '(Не задано)'
        })
        const addInfo = {}
        if (this.report.object.gos_contract !== undefined && this.report.object.gos_contract.state) {
          this.$set(addInfo, 'gosContract', 'Входит в госконтракт')
        }
        if (this.report.object.balance !== undefined) {
          this.$set(addInfo, 'balance', { name: 'Баланс ЦОДД', value: this.report.object.balance ? 'Да' : 'Нет' })
        }
        const ptoObject = ptoActType.map(element => {
          return { key: element, index: 8 }
        })
        data.push(Object.assign({
          name: 'Объект ' + this.objectTypeName,
          article: [
            { key: 'table', index: 12 }, { key: 'detector', index: 12 }, { key: 'tl', index: 6 }, { key: 't7', index: 6 },
            { key: 'kto', index: 15 }, { key: 'fvf', index: 13 }].concat(ptoObject),
          value: this.report.object.number + (objectType == 'detector' ? '' : (' - ' + this.report.object.address)),
          object: this.report.object.number + (objectType == 'detector' ? '' : (' - ' + this.report.object.address)),
          objectLink: this.report.object.objectLink !== undefined ? this.report.object.objectLink : null
        }, !ptoActType.includes() ? { addInfo: addInfo, expansion: 'main' } : {}))
        if (this.report.act.complex !== undefined) {
          this.report.act.complex.forEach((item, indexComplex) => {
            data.push({
              name: item.name,
              article: [{ key: 'fvf', index: 14 + indexComplex }],
              value: item.value
            })
          })
        }
        const ptoCoordinates = ptoActType.map(element => {
          return { key: element, index: 9 }
        })
        data.push(Object.assign({
          name: ['tl', 't7'].includes(objectType) ? 'Уточненные координаты' : 'Координаты',
          article: [{ key: 'table', index: 13 }, { key: 'detector', index: 15 }, { key: 'tl', index: 15 },
            { key: 't7', index: 15 }, { key: 'kto', index: 17 }].concat(ptoCoordinates),
          value: ['tl', 't7'].includes(objectType) ? this.report.act.coordinates : this.report.object.coordinates,
          object: this.report.object.coordinates

        }, !ptoActType.includes() ? {
          synchronical: (['tl', 't7'].includes(objectType) ? this.report.act.coordinates : this.report.object.coordinates) == this.report.object.coordinates,
          expansion: 'main'
        } : {}))
        const ptoProject = ptoActType.map(element => {
          return { key: element, index: 10 }
        })
        if (ptoActType.includes(objectType)) {
          data.push({
            name: 'Проект ПТО',
            article: ptoProject,
            value: this.report.act.project_name
          })
        }
        if (this.report.object.speed_limit !== undefined) {
          data.push({
            name: 'Ограничение скорости',
            article: [{ key: 'kto', index: 19 }],
            value: this.report.object.speed_limit.in_act_value,
            synchronical: this.report.object.speed_limit.synchronical
          })
        }
        if (this.report.object.connection_number !== undefined) {
          data.push({
            name: 'Номер точки подключения',
            article: [{ key: 'kto', index: 20 }],
            value: this.report.object.connection_number.in_act_value,
            synchronical: this.report.object.connection_number.synchronical
          })
        }
        if (this.report.object.connection !== undefined) {
          data.push({
            name: 'Тип электропитания',
            article: [{ key: 'kto', index: 21 }],
            value: this.report.object.connection.in_act_value,
            synchronical: this.report.object.connection.synchronical
          })
        }
        if (this.report.object.type_support !== undefined) {
          data.push({
            name: 'Тип опоры',
            article: [{ key: 'kto', index: 22 }],
            value: this.report.object.type_support.in_act_value,
            synchronical: this.report.object.type_support.synchronical
          })
        }
        if (this.report.object.camera_type !== undefined) {
          data.push({
            name: 'Тип камеры',
            article: [{ key: 'kto', index: 23 }],
            value: this.report.object.camera_type.in_act_value,
            synchronical: this.report.object.camera_type.synchronical
          })
        }
        if (this.report.object.camera !== undefined) {
          data.push({
            name: 'Камера',
            article: [{ key: 'kto', index: 24 }],
            value: this.report.object.camera.in_act_value,
            synchronical: this.report.object.camera.synchronical
          })
        }
        if (this.report.object.mask !== undefined) {
          data.push({
            name: 'Маска сети',
            article: [{ key: 'kto', index: 25 }],
            value: this.report.object.mask.in_act_value,
            synchronical: this.report.object.mask.synchronical
          })
        }
        if (this.report.object.gateway !== undefined) {
          data.push({
            name: 'Шлюз сети',
            article: [{ key: 'kto', index: 26 }],
            value: this.report.object.gateway.in_act_value,
            synchronical: this.report.object.gateway.synchronical
          })
        }
        this.expansionItems = []
        const listClaims = []
        if (this.report.claims) {
          // внешние заявки
          if (this.report.claims.external && this.report.claims.external.length) {
            const defaultClaimType = this.troubleTypeConfig.find(trouble => trouble.id == 5)
            this.report.claims.external.forEach((item, indexExternal) => {
              const typeClaim = this.troubleTypeConfig.find(trouble => trouble.id == item.type)
              const dataClaimsExternal = []
              dataClaimsExternal.push({ name: 'Наименование', value: item.name })
              if (item.object && item.object !== '') {
                dataClaimsExternal.push({ name: 'Объект', value: item.object })
              }
              dataClaimsExternal.push({ name: 'Тип заявки', value: typeClaim !== undefined ? typeClaim.name : defaultClaimType.name })
              dataClaimsExternal.push({ name: 'Комментарий, сопровождающий заявку', value: item.description })
              dataClaimsExternal.push({
                name: ['tl', 't7'].includes(objectType) ? 'Заявку создал' : 'Автор принятия в работу',
                value: item.creator_name,
                link: item.link !== undefined ? item.link : null
              })
              dataClaimsExternal.push({ name: 'Статус', value: item.status_name })
              dataClaimsExternal.push({ name: 'Признак выполнения заявки', value: item.performance })
              listClaims.push({
                key: 'external_' + indexExternal,
                name: item.name,
                model: true,
                data: dataClaimsExternal,
                icon: {
                  name: 'mdi-earth',
                  color: 'light-green-11'
                },
                columns: this.columns,
                lastComment: {
                  name: item.comment_name,
                  comment: item.comment
                }
              })
            })
          }
          // внутренние заявки
          if (this.report.claims.internal && this.report.claims.internal.length) {
            this.report.claims.internal.forEach((item, indexInternal) => {
              const dataClaimsInternal = [
                { name: 'Наименование', value: item.name },
                { name: 'Объект', value: item.object },
                { name: 'Комментарий, сопровождающий заявку', value: item.description },
                { name: 'Заявку создал', value: item.creator_name, link: item.link !== undefined ? item.link : null }
              ]
              listClaims.push({
                key: 'internal_' + indexInternal,
                name: item.name,
                model: true,
                data: dataClaimsInternal,
                icon: {
                  name: 'mdi-home',
                  color: 'indigo-10'
                },
                columns: this.columns,
                lastComment: {
                  name: item.comment_name,
                  comment: item.comment
                }
              })
            })
          }
        }
        if (listClaims.length > 0 && (objectType == 'kto')) {
          data.push({
            name: 'Заявки из Диспетчерской',
            article: [{ key: 'kto', index: 18 }],
            value: listClaims,
            expansionInTable: true
          })
        }

        this.data = data.filter(item => {
          return item.article.find(element => element.key == objectType) !== undefined
        }).sort((previous, next) => {
          const indexPrevious = previous.article.find(element => element.key == objectType).index
          const indexNext = next.article.find(element => element.key == objectType).index
          return (indexPrevious > indexNext) ? 1 : -1
        })
        if (['tl', 't7'].includes(objectType)) {
          const columns = [
            {
              name: 'name',
              align: 'left',
              field: 'name'
            },
            {
              name: 'value',
              align: 'left',
              field: 'value',
              style: 'width:25%;'
            },
            {
              name: 'object',
              align: 'left',
              field: 'object',
              style: 'width:25%;'
            }
          ]
          const dataMain = this.data.filter(item => item.expansion && item.expansion == 'main')
          this.expansionItems.push({ key: 'main', name: 'Общие поля', model: true, data: dataMain, columns: columns })
          const dataRegulations = (this.report.act.regulations && this.report.act.regulations.length) ? this.report.act.regulations : []
          this.expansionItems.push({ key: 'regulations', name: 'Регламент', model: (this.report.act.job_regulations && this.report.act.job_regulations == 'Да'), data: dataRegulations, columns: columns })
          const dataAdaptive = (this.report.act.adaptive && this.report.act.adaptive.length) ? this.report.act.adaptive : []
          this.expansionItems.push({ key: 'adaptive', name: 'Адаптивная система', model: (this.report.act.job_adaptive && this.report.act.job_adaptive == 'Да'), data: dataAdaptive, columns: columns })
          const dataSpecification = (this.report.act.specification && this.report.act.specification.length) ? this.report.act.specification : []
          let modelExpansionSpecification = false
          if (dataSpecification.length) {
            const foundClaimDate = dataSpecification.find(item => item.key == 'claim_date')
            if (foundClaimDate !== undefined && foundClaimDate.value !== '(не задано)') {
              const indexClaimDate = dataSpecification.findIndex(item => item.key == 'claim_date')
              this.$set(dataSpecification[indexClaimDate], 'value', this.formatDateTime(foundClaimDate.value))
              modelExpansionSpecification = true
            }
          }
          this.expansionItems.push({ key: 'specification', name: 'Заявка', model: modelExpansionSpecification, data: dataSpecification, columns: this.columns })
          if (listClaims.length > 0) {
            this.expansionItems = this.expansionItems.concat(listClaims)
          }
          const dataCupboard = (this.report.act.cupboard && this.report.act.cupboard.length) ? this.report.act.cupboard : []
          this.expansionItems.push({ key: 'cupboard', name: 'Эстетика', model: false, data: dataCupboard, columns: columns })
          const dataRemains = []
          if (this.legendConfigTypes && Object.keys(this.legendConfigTypes).length) {
            const legendConfigTypes = JSON.parse(JSON.stringify(this.legendConfigTypes))
            Object.keys(legendConfigTypes).forEach(key => {
              if (legendConfigTypes[key].remainIndex !== undefined) {
                dataRemains.push({
                  name: legendConfigTypes[key].actionName !== undefined ? legendConfigTypes[key].actionName : legendConfigTypes[key].name,
                  value: this.report.act[key] !== undefined ? this.report.act[key] : 'Нет',
                  icon: {
                    name: legendConfigTypes[key].icon,
                    color: this.report.act[key] == 'Да' ? legendConfigTypes[key].colorSuccess : legendConfigTypes[key].colorUnSuccess
                  },
                  object: '',
                  remainIndex: legendConfigTypes[key].remainIndex
                })
              }
            })
            dataRemains.sort((previous, next) => {
              return (previous.remainIndex > next.remainIndex) ? 1 : -1
            })
          }
          const addTypesRemains = [{ name: 'Рекомендован аудит всего СО', key: 'recommended_audit_so' },
            { name: 'Примечание для не рекомендованного аудита', key: 'note_not_recommended_audit' },
            { name: 'Причины доработки акта', key: 'note_rework' },
            { name: 'Примечание аудитора', key: 'note_audit' },
            { name: 'Готов к утверждению', key: 'approve_ready' }]
          addTypesRemains.forEach(typeRemain => {
            dataRemains.push({
              name: typeRemain.name,
              value: this.report.act[typeRemain.key],
              html: !['approve_ready', 'recommended_audit_so'].includes(typeRemain.key),
              object: this.report.object[typeRemain.key] !== undefined ? this.report.act[typeRemain.key] : ''
            })
          })

          this.expansionItems.push({ key: 'remains', name: 'Выполненные работы', model: true, data: dataRemains, columns: columns })
          if (this.report.act.acts_survey !== undefined) {
            const columnsSurvey = [
              {
                name: 'name',
                align: 'left',
                field: 'name'
              },
              {
                name: 'value',
                label: 'Значение в акте',
                align: 'left',
                field: 'value',
                style: 'width:25%;'
              },
              {
                name: 'object',
                label: 'Значение в СО',
                align: 'left',
                field: 'object',
                style: 'width:25%;'
              }
            ]
            this.report.act.acts_survey.main.forEach((item, itemIndex) => {
              if (item.colspan !== undefined) {
                this.$set(this.report.act.acts_survey.main[itemIndex], 'trClass', 'text-bold bg-blue-1')
              } else {
                this.$set(this.report.act.acts_survey.main[itemIndex], 'trClass', 'bg-green-1')
              }
            })
            this.report.act.acts_survey.limitations.forEach((item, itemIndex) => {
              if (item.name == 'Комментарий') {
                this.$set(this.report.act.acts_survey.limitations[itemIndex], 'trClass', 'text-bold bg-green-1')
              } else {
                this.$set(this.report.act.acts_survey.limitations[itemIndex], 'trClass', 'bg-yellow-1')
              }
            })
            const dataSurvey = this.report.act.acts_survey.main
              .concat([
                { name: 'Режим работы СО', colspan: 3, value: '', object: '', trClass: 'text-center text-bold bg-blue-1' },
                { name: this.report.act.acts_survey.operating_mode, colspan: 3, value: '', object: '', trClass: 'text-center text-bold bg-blue-1' }
              ])
              .concat([
                { name: 'Выявленные недостатки', colspan: 3, value: '', object: '', trClass: 'text-center text-bold bg-green-1 ' }
              ])
              .concat(this.report.act.acts_survey.limitations)

            this.expansionItems.push({
              key: 'survey',
              name: 'Обследование СО',
              model: true,
              data: dataSurvey,
              headerClass: 'bg-green-2 text-bold',
              columns: columnsSurvey
            })
          }
          if (this.report.work.washoutPainting !== undefined && this.report.work.washoutPainting.length) {
            const columnsWashoutPainting = [
              {
                name: 'name',
                label: 'Наименование',
                align: 'left',
                field: 'name',
                sortable: true,
                srtyle: 'width: 50%'
              },
              {
                name: 'washoutQuantity',
                label: 'Помывка',
                align: 'left',
                field: 'washoutQuantity'
              },
              {
                name: 'washoutAuditQuantity',
                label: 'Аудит',
                align: 'left',
                field: 'washoutAuditQuantity'
              },
              {
                name: 'paintingQuantity',
                label: 'Покраска',
                align: 'left',
                field: 'paintingQuantity'
              },
              {
                name: 'paintingAuditQuantity',
                label: 'Аудит',
                align: 'left',
                field: 'paintingAuditQuantity'
              },
              {
                name: 'paintingQuantityTotal',
                label: 'Всего',
                align: 'left',
                field: 'paintingQuantityTotal'
              },
              {
                name: 'paintingAuditQuantityTotal',
                label: 'Аудит',
                align: 'left',
                field: 'paintingAuditQuantityTotal'
              }
            ]
            const dataWashoutPainting = []
            this.report.work.washoutPainting.forEach(item => {
              dataWashoutPainting.push({
                name: item.name,
                washoutQuantity: (item.washout !== undefined && item.washout.quantity !== undefined) ? item.washout.quantity : 0,
                washoutAuditQuantity: (item.washout !== undefined && item.washout.audit_quantity !== undefined) ? item.washout.audit_quantity : 0,
                paintingQuantity: (item.painting !== undefined && item.painting.quantity !== undefined) ? item.painting.quantity : 0,
                paintingAuditQuantity: (item.painting !== undefined && item.painting.audit_quantity !== undefined) ? item.painting.audit_quantity : 0,
                paintingQuantityTotal: (item.painting !== undefined && item.painting.quantity_total !== undefined) ? item.painting.quantity_total : 0,
                paintingAuditQuantityTotal: (item.painting !== undefined && item.painting.audit_quantity_total !== undefined) ? item.painting.audit_quantity_total : 0,
                tdClass: { done: item.testDone ? 'bg-yellow-2' : 'bg-green-1 ', total: item.testTotal ? 'bg-yellow-2' : 'bg-green-1 ' }
              })
            })
            this.expansionItems.push({
              key: 'washoutPainting',
              name: 'Выполненные работы по покраске/помывке',
              model: true,
              data: dataWashoutPainting,
              headerClass: 'bg-green-2 text-bold',
              columns: columnsWashoutPainting
            })
          }
        }
        if (this.report.equipments && (this.report.equipments.install || this.report.equipments.remote)) {
          this.dataEquipments = [{
            remote: this.report.equipments.remote.length ? this.report.equipments.remote : 'Демонтаж не производился',
            install: this.report.equipments.install.length ? this.report.equipments.install : 'Установка не производилась',
            table: { install: this.report.equipments.install.length > 0, remote: this.report.equipments.remote.length > 0 },
            columns: [
              {
                name: 'name',
                label: 'Материал',
                align: 'left',
                field: 'name',
                sortable: true
              },
              {
                name: 'quantity',
                label: 'Использовано',
                align: 'left',
                field: 'quantity'
              }
            ]
          }]
        }
        // dataFilledEngineer, dataRoadInfo
        if (objectType == 'detector') {
          this.dataFilledEngineer.push({ name: 'Округ', value: this.report.object.area })
          this.dataFilledEngineer.push({
            name: 'Тип датчика',
            value: this.report.object.type_name.value,
            synchronical: this.report.object.type_name.synchronical
          })
          this.dataFilledEngineer.push({
            name: 'Доп.информация к датчику SMS',
            value: this.report.object.type_addition.value,
            synchronical: this.report.object.type_addition.synchronical
          })
          if (this.report.object.type_name.value && this.report.object.type_name.value !== '(не задано)') {
            this.dataFilledEngineer.push({ name: 'Ориентация (для SMS)', value: this.report.object.orientation })
          }
          this.dataFilledEngineer.push({ name: '№ комплекса', value: this.report.object.number })
          this.dataFilledEngineer.push({ name: 'Серийный номер датчика', value: this.report.object.serial_number })
          this.dataFilledEngineer.push({ name: 'Тип опоры', value: this.report.object.type_support_name })
          this.dataFilledEngineer.push({ name: 'Высота установки датчика', value: this.report.object.height_set })
          this.dataFilledEngineer.push({ name: 'Корректировка адреса', value: this.report.object.address_rename })
          this.dataFilledEngineer.push({ name: 'Адрес монтажа', value: this.report.act.address, synchronical: (this.report.act.address == this.report.object.address) })
          this.dataFilledEngineer.push({ name: 'Координаты', value: this.report.act.coordinates, synchronical: (this.report.act.coordinates == this.report.object.coordinates) })
          this.dataFilledEngineer.push({ name: 'Тип подключения к сети', value: this.report.object.connection_name })
          this.dataFilledEngineer.push({
            name: 'Внешний IP4 адрес',
            value: this.report.object.ip4.value,
            synchronical: this.report.object.ip4.synchronical
          })

          this.dataRoadInfo.push({ name: 'Количество направлений', value: this.report.object.road_info.set_count_orientation })
          this.dataRoadInfo.push({ name: 'Количество полос в направлении', value: this.report.object.road_info.set_count_strip })
          this.dataRoadInfo.push({ name: 'Реверсивная полоса', value: this.report.object.road_info.set_revers })
          if (this.report.object.road_info.set_revers == 'да') {
            this.dataRoadInfo.push({ name: 'Номер реверсивной полосы', value: this.report.object.road_info.set_revers_number })
          }
          this.dataRoadInfo.push({ name: 'Количество полос общественного транспорта', value: this.report.object.road_info.set_public })
          if (this.report.object.road_info.set_public !== 'нет') {
            this.dataRoadInfo.push({ name: 'Номера полос для общественного транспорта', value: this.report.object.road_info.set_public_number })
          }
          this.$set(this.dataMarkerComplex[0], 'value', this.report.object.number_box)
          if (this.report.object.disassembling_address && this.report.object.disassembling_address !== '') {
            const indexNumber = this.dataDemounting.findIndex(item => item.key == 'number_old')
            this.$set(this.dataDemounting[indexNumber], 'value', this.report.object.number_old)
            const indexCoordinates = this.dataDemounting.findIndex(item => item.key == 'coordinates_old')
            this.$set(this.dataDemounting[indexCoordinates], 'value', this.report.object.coordinates_old)
            const indexDisassemblingAddress = this.dataDemounting.findIndex(item => item.key == 'disassembling_address')
            this.$set(this.dataDemounting[indexDisassemblingAddress], 'value', this.report.object.disassembling_address)
          }
          // AUDIT
          this.dataAudit.push({ name: 'Доступность объекта', value: this.report.audit.access_restricted })
          this.dataAudit.push({ name: 'Статус аудита', value: this.report.audit.status_name })
          this.dataAudit.push({
            name: 'Аудитор',
            value: this.report.audit.auditor_name,
            link: this.report.audit.employee_link !== undefined ? this.report.audit.employee_link : null
          })
          this.dataAudit.push({ name: 'Время аудита', value: this.formatDateTime(this.report.audit.time) })
          this.dataAudit.push({ name: 'Результат аудита', value: this.report.audit.result.replace(/margin-left:-/g, 'margin-left:') })
          this.dataAudit.push({ name: 'Примечание аудитора', value: this.report.audit.note.replace('<br/>', '') })
        }
        if (this.report.act.complex_cameras !== undefined && this.report.act.complex_cameras.length > 0) {
          this.dataComplexCameras = []
          const columnsComplexCamera = [
            {
              name: 'name',
              label: 'Тип',
              align: 'left',
              field: 'name',
              sortable: true
            },
            {
              name: 'coordinates',
              label: 'Координаты',
              align: 'left',
              field: 'coordinates',
              sortable: true
            },
            {
              name: 'direction',
              label: 'Направление',
              align: 'left',
              field: 'direction',
              sortable: true
            }]
          this.$set(this.dataComplexCameras, 'title', 'Камеры')
          this.$set(this.dataComplexCameras, 'columns', columnsComplexCamera)
          const dataComplex = []
          this.report.act.complex_cameras.forEach(item => {
            dataComplex.push({ name: item.name, coordinates: item.coordinates, direction: item.direction })
          })
          this.$set(this.dataComplexCameras, 'data', dataComplex)
        }
        if (this.report.act.cameras !== undefined && this.report.act.cameras.length > 0) {
          const columnsCamera = []
          getToken()
            .then((response) => {
              if (response.data.error_code == 0) {
                this.report.act.cameras.forEach((item, itemIndex) => {
                  const dataCamera = { name: item.title }
                  if (itemIndex == 0) {
                    columnsCamera.push({
                      name: 'name',
                      align: 'left',
                      field: row => row.title,
                      classes: 'bg-light-blue-10 text-white ellipsis'
                    })
                  }
                  item.data.forEach(camera => {
                    this.$set(dataCamera, camera.key, camera.value)
                    if (itemIndex == 0) {
                      columnsCamera.push({
                        name: camera.key,
                        align: 'left',
                        field: camera.key,
                        label: camera.name
                      })
                    }
                  })

                  const dataToken = response.data.token
                  this.getPhoto(dataToken, this.objectType, +item.photo_rakurs, true).then(result => {
                    this.$set(dataCamera, 'photoRakurs', {
                      url: 'data: ' + result.data.data.mime_content_type + ';base64,' + result.data.data.base64,
                      id: item.photo_rakurs,
                      name: 'Ракурс камеры объекта'
                    })
                  })

                  this.dataCameras.push(dataCamera)
                  if (itemIndex == 0) {
                    this.columnsCameras = columnsCamera
                  }
                })
              }
            })
        }
        this.dataMaterials = this.report.materials
        this.$set(this.dataMaterialDescription[0], 'value', this.report.materials_description ? this.report.materials_description : ' - ')
      }
    })
  },
  methods: {
    formatDateTime: function (unixTime) {
      return unixTime ? convertTime(unixTime * 1000) : ''
    },
    openPreview: function (index, alias = 'photoWorks', name = '') {
      let _photos = []
      if (alias == 'rakurs') {
        _photos.push(this.dataCameras.find(item => item.name == name).photoRakurs)
      } else {
        _photos = this.photosStatus.photos[alias]
      }
      this.$refs.imagesViewer.show(_photos, index)
    },
    showNote: function (type) {
      switch (type) {
        case 'rework':
          this.showNoteRework = !this.showNoteRework
          break
        case 'checked':
          this.showNoteChecked = !this.showNoteChecked
          break
        default:
          break
      }
    },
    getClassStatusJob: function (status) {
      let classStatusJob = 'bg-red-1'
      switch (status) {
        case 1:
          classStatusJob = 'bg-green-4'
          break
        case 2:
          classStatusJob = 'bg-yellow-3'
          break
        default:
          break
      }
      return classStatusJob
    },
    getNodesTree: function (jobs) {
      const testJobs = jobs.map(function (job) {
        const newJob = Object.assign({}, job)
        newJob.disabled = true
        return { ...newJob }
      })
      return [...new Set([...testJobs])]
    },
    getPhoto: function (token, type, id, rakurs = false) {
      const bodyFormData = new FormData()
      bodyFormData.append('token', token)
      bodyFormData.append('type', type)
      bodyFormData.append('photo_id', id)
      if (rakurs) {
        bodyFormData.append('rakurs', true)
      }
      return axiosPost({
        url: 'api-v1/api-act-objects/get-photo',
        config: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          withCredentials: true
        },
        data: bodyFormData,
        onSuccess: (response) => {
          return Promise.resolve(response)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(response.message))
        }
      })
    },
    getFile: function (token, id) {
      const bodyFormData = new FormData()
      bodyFormData.append('token', token)
      bodyFormData.append('file_id', id)
      return axiosPost({
        url: 'api-v1/api-act-objects/get-file',
        config: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          withCredentials: true
        },
        data: bodyFormData,
        onSuccess: (response) => {
          return Promise.resolve(response)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(response.message))
        }
      })
    },
    getClassRow: function (name, row) {
      let classRow = ''
      if (name == 'value' && row.synchronical !== undefined && !['tl', 't7'].includes(this.objectType)) {
        classRow = row.synchronical ? '' : 'bg-red-2 '
      } else if (name == 'name') {
        classRow = 'text-bold'
      } else if (name == 'object' && row.synchronical !== undefined && ['tl', 't7'].includes(this.objectType)) {
        classRow = row.synchronical ? '' : 'text-negative'
      }
      return classRow
    },
    loadFile: function () {
      if (!this.filesStatus.files.length || this.filesStatus.files.length) {
        const amountFiles = this.filesStatus.files.length
        const totalFiles = this.filesStatus.status.count
        const filesNumber = Math.min(amountFiles + 10, totalFiles)
        const _files = [...this.report.act.files]
        this.$set(this.filesStatus.status, 'liner', 0)
        getToken()
          .then((response) => {
            if (response.data.error_code == 0) {
              const dataToken = response.data.token
              const newListFiles = [...this.filesStatus.filesData]
              this.$set(this.filesStatus.status, 'loading', true)
              let linerIndex = filesNumber - amountFiles
              _files.forEach(id => {
                this.getFile(dataToken, +id).then(result => {
                  const foundFile = newListFiles.find(item => item.id == id)
                  linerIndex--
                  this.$set(this.filesStatus.status, 'liner', 1 - (linerIndex / 10))
                  if (foundFile == undefined) {
                    newListFiles.push({
                      url: 'data: ' + result.data.data.mime_content_type + ';base64,' + result.data.data.base64,
                      id: id,
                      name: result.data.data.file_name,
                      status_name: 'Вложенные файлы'
                    })
                  }
                })
              })
              this.$set(this.filesStatus.status, 'loading', false)
              this.$set(this.filesStatus, 'filesData', newListFiles)
            }
          })
      }
    },
    loadPhoto: function (index) {
      if (!this.photosStatus.photos[index].length || this.photosStatus.photos[index].length < this.photosStatus.status[index].count) {
        const amountPhotos = this.photosStatus.photos[index].length
        const totalPhotos = this.photosStatus.status[index].count
        const statusName = this.photosStatus.status[index].name
        const photosNumber = Math.min(amountPhotos + 10, totalPhotos)
        const _photos = [...this.report.photos].filter(photo => photo.status_name == statusName).slice(amountPhotos, photosNumber)
        this.$set(this.photosStatus.status[index], 'liner', 0)
        getToken()
          .then((response) => {
            if (response.data.error_code == 0) {
              const dataToken = response.data.token
              const newListPhotos = [...this.photosStatus.photos[index]]
              this.$set(this.photosStatus.status[index], 'loading', true)
              let linerIndex = photosNumber - amountPhotos
              _photos.forEach(item => {
                this.getPhoto(dataToken, item.type, +item.id).then(result => {
                  const foundPhoto = newListPhotos.find(photo => photo.id == item.id)
                  linerIndex--
                  this.$set(this.photosStatus.status[index], 'liner', 1 - (linerIndex / 10))
                  if (foundPhoto == undefined) {
                    newListPhotos.push({
                      url: 'data: ' + result.data.data.mime_content_type + ';base64,' + result.data.data.base64,
                      id: item.id,
                      name: item.id + ' - ' + item.status_name,
                      status_name: item.status_name
                    })
                  }
                })
              })
              this.$set(this.photosStatus.status[index], 'loading', false)
              this.$set(this.photosStatus.photos, index, newListPhotos)
            }
          })
      }
    },
    openDialogReLoad: function (index, id) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            const newListPhotos = [...this.photosStatus.photos[index]]
            const foundPhoto = newListPhotos.find(photo => photo.id == id)
            const foundPhotoIndex = newListPhotos.findIndex(photo => photo.id == id)
            this.$set(this.photosStatus.status[index], 'loading', true)
            getToken()
              .then((response) => {
                if (response.data.error_code == 0) {
                  const dataToken = response.data.token
                  const newPhoto = {}
                  this.getPhoto(dataToken, this.objectType, +id).then(result => {
                    this.$set(newPhoto, 'url', 'data: ' + result.data.data.mime_content_type + ';base64,' + result.data.data.base64)
                    this.$set(newPhoto, 'id', id)
                    this.$set(newPhoto, 'name', id + ' - ' + foundPhoto.status_name)
                    this.$set(newPhoto, 'status_name', foundPhoto.status_name)
                    this.$set(this.photosStatus.photos[index], foundPhotoIndex, {})
                    this.$set(this.photosStatus.photos[index], foundPhotoIndex, newPhoto)
                  })

                  this.$set(this.photosStatus.status[index], 'loading', false)
                }
              })
          }
        },
        warning: 'Обновить получение фото?\n',
        buttons: [
          { key: 'yes', name: 'Да', color: 'primary' },
          { key: 'no', name: 'Отмена', color: 'white' }
        ]
      })
    },
    onDownloadFile: function (dataFile, fileName) {
      const downloadLink = document.createElement('a')
      downloadLink.href = dataFile
      downloadLink.download = fileName
      downloadLink.click()
    },
    getClassRowStrip: function (row) {
      return row.strip ? 'table-tr-strip' : ''
    }
  }
}
